import React from 'react'
import MediaCarousel from '../../../shared/components/MediaCarousel'
import { Paper, useMediaQuery, useTheme } from '@mui/material'

const Gallery: React.FC = () => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const images = [
    'images/test.jpg',
    'images/test.jpg',
  ]

  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <MediaCarousel items={images} navButtonsAlwaysVisible maxWidth='100%' />
    </Paper>
    // <div>Hier kommen Bilder rein</div>
  )
}

export default Gallery
